// src/services/axiosConfig.js
import axios from 'axios';
const apiClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api/`,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  timeout: 5000, // Optional: Set a timeout for requests
});

// Optional: Add request/response interceptors
apiClient.interceptors.request.use(
  (config) => {
    // Modify request config if needed (e.g., add authentication tokens)
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle errors globally
    return Promise.reject(error);
  }
);

export default apiClient;
